

import { BaseEntity, CommonSettingEntity } from '@m4u-angular/base/entities/BaseEntities';

export class State extends BaseEntity
{   
    public Code: string; 
    public CountryCode: string; 
    public Name: string; 
	
}



